<style lang="scss" scoped>
.finish {
  height: 58px;
  @include text(11px, #999);
  @include flex-row-center;
}
.logo {
  width: 123px;
  height: 18px;
}
</style>

<template>
  <div class="finish">
    <img
      v-if="useLogo"
      src="@/images/goods_rank/bottom_tip_logo_mall.png"
      class="logo"
    />
    <span v-else>-已经到底啦-</span>
  </div>
</template>

<script>
export default {
  name: 'PageBottom',
  props: {
    useLogo: {
      type: Boolean,
      default: false
    }
  }
}
</script>
